import * as DICOMwebClient from 'dicomweb-client';

let inited = false;

const clients: { qidoClient: any; wadoClient: any } = {
  qidoClient: null,
  wadoClient: null,
};

export function init(wadoBaseUrl: string, qidoBaseUrl: string) {
  // Instead of using one client with baseurl and qido/wado prefixes, just create two clients in the
  // event that there isn't a clear shared base url. This gives more flexibility in configuration.
  clients.qidoClient = new DICOMwebClient.api.DICOMwebClient({
    url: qidoBaseUrl,
  });
  clients.wadoClient = new DICOMwebClient.api.DICOMwebClient({
    url: wadoBaseUrl,
  });
  inited = true;
  return clients;
}

export function getClients() {
  if (!inited) {
    throw new Error('DICOMweb clients have not been initialized');
  }
  return clients;
}
